import { translations } from '@prezly/theme-kit-intl';
import classNames from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';

import { PageTitle } from '@/components';
import { CUSTOM_MESSAGES } from '@/intl/messageDescriptors';

import SearchBar from './SearchBar';
import { useSearchState } from './SearchStateContextProvider';

import styles from './Title.module.scss';

function Title() {
    const { formatMessage } = useIntl();
    const { searchState, searchResults } = useSearchState();

    const { query: searchQuery } = searchState;
    const resultsCount = searchResults ? searchResults.nbHits : 0;

    return (
        <PageTitle
            title={
                searchQuery
                    ? formatMessage(translations.search.fullResultsTitle)
                    : formatMessage(translations.search.title)
            }
            subtitle={
                searchQuery ? (
                    <FormattedMessage
                        {...translations.search.fullResultsSubTitle}
                        values={{
                            resultsCount: <b>{resultsCount}</b>,
                            searchQuery: (
                                <>
                                    &quot;<b>{searchQuery}</b>&quot;
                                </>
                            ),
                        }}
                    />
                ) : undefined
            }
            className={classNames({
                [styles.empty]: !searchQuery,
            })}
            paths={[
                { title: formatMessage(CUSTOM_MESSAGES.site.home), href: '/' },
                { title: formatMessage(translations.search.title) },
            ]}
        >
            <SearchBar />
        </PageTitle>
    );
}

export default Title;
